import { render, staticRenderFns } from "./suggestview.vue?vue&type=template&id=95311160&scoped=true&"
import script from "./suggestview.vue?vue&type=script&lang=js&"
export * from "./suggestview.vue?vue&type=script&lang=js&"
import style0 from "./suggestview.vue?vue&type=style&index=0&id=95311160&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95311160",
  null
  
)

export default component.exports